import { v4 as uuidv4 } from 'uuid';
import { FC, useEffect, useState } from "react";
import { IDocumentCreatorProps } from "../../../../@types/documents";
import { useAppContext } from "../../../../system/providers/appContextProvider";
import { useTabsContext } from "../../../../system/providers/tabsProvider";
import { IKizInventoryEditDTO, IKizInventoryGetDTO } from '../../../../libs/coreapi-dto/accounting/kizInventory/kizInventory';
import { KizInventoryDataProvider } from '../../../../Services/DataProviders/KizInventoryDataProvider';
import { KizInventoryCreator } from '..';

interface ICreateDocument {
    callback: (entity: IKizInventoryEditDTO, withClose: boolean) => void
    saveCallback: (entity: IKizInventoryEditDTO) => void;
}

interface IEditDocument {
    callback: (id: string, entity: IKizInventoryEditDTO, withClose: boolean) => void
    entity: IKizInventoryGetDTO
}

interface ICopyDocument {
    callback: (entity: IKizInventoryEditDTO, withClose: boolean) => void
    entity: IKizInventoryGetDTO
    saveCallback: (entity: IKizInventoryEditDTO) => void;
}

export const KizInventoryCreatorView: FC<IDocumentCreatorProps<IKizInventoryEditDTO>> = (props) => {
    const appContext = useAppContext();
    const tabsContext = useTabsContext();
    const kizInventoryDP = new KizInventoryDataProvider(appContext.coreApiService);

    const [viewState, setViewState] = useState<GridStateType>(props.variant)
    const [id, setId] = useState<string | undefined>(props.idGlobal)
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [createDocument, setCreateDocument] = useState<ICreateDocument | null>(null);
    const [editDocument, setEditDocument] = useState<IEditDocument | null>(null);
    const [copyDocument, setCopyDocument] = useState<ICopyDocument | null>(null);
    const uuidv = uuidv4();

    useEffect(() => {

        if (viewState === 'create') {
            const createCallback = (entity: IKizInventoryEditDTO, withClose: boolean) => {
                setIsSubmitting(true)
                kizInventoryDP.create(entity, (id) => {
                    setId(id)
                    setViewState('create')
                    props.createdCallback?.()
                    withClose && tabsContext.closeCurrent()
                    setIsSubmitting(false)
                }, ()=>{}, (e)=>{
                    setIsSubmitting(false);
                })
            }
            const saveCallback = (entity: IKizInventoryEditDTO) => {
                setIsSubmitting(true);
                kizInventoryDP.create(entity, (id) => {
                    setId(id);
                    setViewState("edit");
                    props.createdCallback?.();
                    setIsSubmitting(false);
                }, ()=>{}, (e)=>{
                    setIsSubmitting(false);
                });
            };
            setCreateDocument({ callback: createCallback, saveCallback: saveCallback })
        }

        if (viewState === 'edit') {
            const editCallback = (id: string, entity: IKizInventoryEditDTO, withClose: boolean) => {
                setIsSubmitting(true)
                kizInventoryDP.update(id as string, entity, (e) => {
                    props.createdCallback?.(entity)
                    if (withClose) {
                        tabsContext.closeCurrent()
                    }
                    setIsSubmitting(false)
                })
            }
            kizInventoryDP.getById(id as string, async (entity) => {
                setEditDocument({ callback: editCallback, entity: entity })
            })
        }

        if (viewState === 'copy') {
            const copyCallback = (entity: IKizInventoryEditDTO, withClose: boolean) => {
                setIsSubmitting(true)
                kizInventoryDP.create(entity, (id) => {
                    setId(id)
                    setViewState('create')
                    props.createdCallback?.()
                    withClose && tabsContext.closeCurrent()
                    setIsSubmitting(false)

                }, ()=>{}, (e)=>{
                    setIsSubmitting(false);
                })
            }
            const copySaveCallback = (entity: IKizInventoryEditDTO) => {
                setIsSubmitting(true);
                kizInventoryDP.create(entity, (id) => {
                    setId(id);
                    setViewState("edit");
                    props.createdCallback?.();
                    setIsSubmitting(false);
                }, ()=>{}, (e)=>{
                    setIsSubmitting(false);
                });
            };
            kizInventoryDP.getById(id as string, async (entity) => {
                entity = {
                    ...entity,
                    idGlobal: uuidv,
                    items: entity.items?.map((item) => { return { ...item, idGlobal: uuidv } }),
                }
                setCopyDocument({ callback: copyCallback, entity: entity, saveCallback: copySaveCallback })
            })
        }

    }, [viewState])

    return (
        <>
            {
                viewState === 'create' ?
                    createDocument && <KizInventoryCreator
                        isSubmitting={isSubmitting}
                        variant="create"
                        idGlobal={uuidv}
                        save={(entity) => createDocument.saveCallback(entity)}
                        ok={(entity) => createDocument.callback(entity, true)}
                        cancel={() => tabsContext.closeCurrent()}
                        permission={props.permission}
                    />
                    :
                    viewState === 'edit' ?
                        editDocument && <KizInventoryCreator
                            isSubmitting={isSubmitting}
                            idGlobal={id}
                            variant="edit"
                            document={editDocument.entity}
                            save={(value) => editDocument.callback(id as string, value, false)}
                            ok={(value) => editDocument.callback(id as string, value, true)}
                            cancel={() => tabsContext.closeCurrent()}
                            permission={props.permission}
                        />
                        :
                        viewState === 'copy' ?
                            copyDocument && <KizInventoryCreator
                                isSubmitting={isSubmitting}
                                idGlobal={uuidv}
                                variant="copy"
                                document={copyDocument.entity}
                                save={(value) => copyDocument.saveCallback(value)}
                                ok={(value) => copyDocument.callback(value, true)}
                                cancel={() => tabsContext.closeCurrent()}
                                permission={props.permission}
                            />
                            :
                            <></>
            }
        </>
    )
}